package org.example.project.utils

import androidx.compose.runtime.Composable
import org.example.project.dashboard.DashboardTheme
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun DashboardVerlaufHintergrund() {
    Div({
        style {
            position(Position.Fixed)
            top(0.px)
            left(0.px)
            right(0.px)
            bottom(0.px)
            backgroundColor(Color(DashboardTheme.DASHBOARD_BG))
            property("background", DashboardTheme.DASHBOARD_BG)
            property("pointer-events", "none")
            property("z-index", "0")
        }
    })
}
